import "../styles/AboutMe.css";
import photoA from "../assets/img/picture-2.png";
import photoB from "../assets/img/picture-3.png";
import {useEffect} from "react";

export default function AboutMe() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <main className="aboutme">
            {/* HERO */}
            <section className="aboutme-hero">
                <div className="container">
                    <h1>Chi Sono</h1>
                    <p className="kicker">Dott. Giammarco Lamanda</p>
                </div>
            </section>

            <section className="aboutme-intro">
                <div className="container narrow">
                    <p>
                        Che tu corra lunghe distanze, pratichi sport di resistenza o cerchi la massima esplosività negli
                        sport di potenza, il mio obiettivo è uno: portarti al livello successivo.
                    </p>
                    <p>
                        Il percorso non si ferma alla dieta: insieme lavoriamo anche su sonno, recupero ed equilibrio
                        psicofisico, perché la vera performance nasce da un corpo nutrito e una mente rigenerata.
                        Non lasciare i tuoi risultati al caso: costruiscili, passo dopo passo.
                    </p>
                </div>
            </section>

            <section className="aboutme-split">
                <div className="container split">
                    <div className="media">
                        {/*<h2 className="media-title">Dott. Giammarco Lamanda</h2>*/}
                        <img src={photoA} alt="Giammarco Lamanda"/>
                    </div>
                    <div className="content">

                        <h3>Il mio percorso <em>Accademico</em></h3>
                        <p>
                            Sono laureato in Scienze dell’Alimentazione e della Nutrizione Umana presso il Campus
                            Bio-Medico di Roma, dove ho conseguito sia la laurea triennale che quella magistrale con
                            110/110 e Lode. Successivamente ho intrapreso un secondo percorso di studi, ottenendo la
                            Laurea Magistrale in Scienze e Tecniche delle Attività Motorie Preventive e Adattate, che mi
                            ha permesso di integrare le competenze nutrizionali con una solida formazione in ambito
                            motorio e rieducativo.
                        </p>
                        <p>
                            Ho poi scelto di specializzarmi ulteriormente completando il Corso di Alta Formazione in
                            Nutrizione e Integrazione Sportiva (SANIS), dove la mia tesina è stata selezionata tra le 10
                            migliori a livello nazionale. Per affinare il mio approccio critico e personalizzato alla
                            nutrizione e alla gestione del paziente, ho infine completato con successo il Master in
                            Medicina e Nutrizione Funzionale (SMNF).
                        </p>
                        <p> A completamento della mia formazione ho conseguito anche la certificazione internazionale
                            ISAK di primo livello in antropometria, strumento fondamentale per valutare in modo
                            scientifico la composizione corporea e monitorare i cambiamenti legati a nutrizione,
                            allenamento e performance.
                        </p>
                        <p>
                            Il mio percorso accademico e formativo riflette la volontà di unire la ricerca scientifica
                            con l’applicazione pratica, offrendo un approccio integrato alla salute, alla performance e
                            al benessere della persona.
                        </p>
                    </div>
                </div>
            </section>

            <section className="aboutme-split alt">
                <div className="container split">
                    <div className="content">
                        <h3>Il mio percorso <em>Lavorativo</em></h3>
                        <p>
                            Nel corso degli anni ho maturato una solida esperienza nell’ambito della nutrizione
                            sportiva, seguendo da vicino atleti di diverse discipline come sport di endurance, CrossFit
                            e podismo, ma anche persone che desiderano migliorare la propria composizione corporea, il
                            benessere e lo stile di vita.
                        </p>
                        <p>
                            Ho avuto l’opportunità di lavorare presso un centro di riferimento per la salute e la
                            performance, una realtà che si prende cura del benessere in ogni sua sfaccettatura,
                            integrando competenze di nutrizione sportiva e clinica, allenamento, sonno e recupero,
                            integrazione, gestione dello stress e mindset. Questo contesto multidisciplinare mi ha
                            permesso di sviluppare una visione ampia e completa, dove ogni aspetto è considerato parte
                            integrante di un percorso personalizzato per l’atleta e per la persona.
                        </p>
                        <p>
                            Attraverso queste esperienze ho affinato un approccio scientifico, pratico e su misura, che
                            non si limita alla semplice prescrizione alimentare, ma che tiene conto dei bisogni
                            individuali, degli obiettivi sportivi, della prevenzione e della salute a lungo termine.
                        </p>
                        <p>
                            Oggi metto a disposizione questa competenza per offrire un supporto che unisce la nutrizione
                            con la preparazione atletica e gli aspetti legati al recupero e al benessere psicofisico,
                            con l’obiettivo di accompagnare ogni persona verso una performance ottimale e uno stile di
                            vita sano ed equilibrato.
                        </p>

                        <a href="/contacts" className="btn btn-contact">
                            Contattami <span className="arrow">→</span>
                        </a>
                    </div>

                    <div className="media">
                        <img src={photoB} alt="Giammarco Lamanda"/>
                    </div>
                </div>
            </section>
        </main>
    );
}